import React, { createContext, useCallback, useContext, ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { pb } from '../../../shared/api/pocketbase';
import { BoardStage } from './types';

interface BoardContextValue {
  stages: BoardStage[];
  isLoading: boolean;
  fetchStages: () => Promise<void>;
}

const BoardContext = createContext<BoardContextValue | null>(null);

export const BoardProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: stages = [], isLoading, refetch } = useQuery({
    queryKey: ['board', 'stages'],
    queryFn: () => pb.collection('board').getFullList<BoardStage>({ sort: 'order', fields: 'id,name,order,actual,colors' }),
    staleTime: 5_000,
  });

  const fetchStages = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return (
    <BoardContext.Provider value={{ stages, isLoading, fetchStages }}>
      {children}
    </BoardContext.Provider>
  );
};

export function useBoard(): BoardContextValue {
  const ctx = useContext(BoardContext);
  if (!ctx) throw new Error('useBoard must be used inside BoardProvider');
  return ctx;
}
